import { BASE_URL } from '../../App'
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Card } from 'antd';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LOGO from '../image/cri_logo.jpg';
import CustomTextField from "../Reusable/Numerictext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Collapse, FormGroup, Stack, Box, Backdrop, createTheme, ThemeProvider, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText, Checkbox, Grid, FormControlLabel } from '@mui/material';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { blue } from '@mui/material/colors';
import { saveAs } from 'file-saver';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import SearchIcon from '@mui/icons-material/Search';
import { Button as Btn, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
const styles = {
  tableContainer: {
    maxHeight: '400px',
    overflowY: 'auto',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: blue[500], // Using MUI blue primary color
    color: '#ffffff',
    textAlign: 'center',
    fontSize: '1rem',
  },
  bodyCell: {
    padding: '12px 16px',
    textAlign: 'center',
    fontSize: '0.875rem',
  },
  debitCreditCell: {
    padding: '12px 16px',
    textAlign: 'right',
    fontSize: '0.875rem',
  },
  tableRow: (index) => ({
    backgroundColor: index % 2 === 0 ? '#f1f1f1' : '#ffffff',
  }),
};

export default function PriceList() {


  const [subdealerlist, setsubdealerlist] = useState([]);

  const [showCard, setShowCard] = useState(false);
  const [open, setOpen] = React.useState(false);


  const [selectedDealer, setSelectedDealer] = useState(null);


  const login_id = localStorage.getItem("LOGIN_ID");
  const BRANCH_CODE = localStorage.getItem('BRANCH_CODE');
  const userGroupCode = localStorage.getItem('usertype');
  const token = localStorage.getItem('Token');
  const headers = { Authorization: `Bearer ${token}` };
  const [selectedValue, setSelectedValue] = useState({});

  const [selectedDate, setSelectedDate] = useState(dayjs());

  const [tableData, setTableData] = useState([]);
  const [period, setperiod] = useState(null);
  const [closing, setclosing] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedname, setSelectedname] = useState('');

  const [showTable, setShowTable] = useState(true);
  const [showTableCOMMONON, setshowTableCOMMONON] = useState(false);
  const [showfirstpage, setShowfirstpage] = useState(true);

  const [showactivity, setShowactivity] = useState(false);
  const [showcommon, setShowcommon] = useState(false);
  const [showexecutivedetails, setexecutivedetails] = useState(true);


  const [isActivityGroupFetched, setIsActivityGroupFetched] = useState(false);
  const [activitygrouplist, setactivitygrouplist] = useState([]);
  const [selectedactivitygroup, setSelectedactivitygroup] = useState(null);

  const [description, setdescription] = useState('');
  const [budget, setbudget] = useState('');
  const [Remark, setRemark] = useState('');
  const [dealerbudget, setdealerbudget] = useState('');
  const [dealerremark, setdealerremark] = useState('');
  const [expresult, setexpresult] = useState('');

  const billNoInputRef = useRef(null);
  const fromdateInputRef = useRef(null);
  const todateInputRef = useRef(null);
  const activityobjectInputRef = useRef(null);
  const budgetInputRef = useRef(null);
  const dealerbudgetInputRef = useRef(null);
  const dealerremarkInputRef = useRef(null);
  const txtSPECIFIC_DETAILS2InputRef = useRef(null);
  const [error, setError] = useState(null);
  const [errorfromdate, setErrorfromdate] = useState(null);
  const [errortodate, setErrortodate] = useState(null);
  const [erroractivityobject, setErroractivityobject] = useState(null);
  const [errorbudget, setErrorbudget] = useState(null);
  const [errordealerbudget, setErrordealerbudget] = useState(null);
  const [errordealerremark, setErrordealerremark] = useState(null);
  const [errortxtSPECIFIC_DETAILS2, setErrortxtSPECIFIC_DETAILS2] = useState(null);


  const [upload, setUpload] = useState([]);
  const [serialNoImage, setSerialNoImage] = useState([]);
  const handleuploadChange = (info) => {
    if (info.fileList) {
      setUpload(info.fileList); // Update the state with the file list
    }
  };


  // const login_id = "s4nQJJzkLN0X1YSjek9P86wH+83VnZxnTdzOohjEBN8psBDaMVVGjVVzZVYsz9UdoYDsvZtKrGFK85UoDHPv8A==";
  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  const handlGroupChange = (event, newValue) => {
    console.log('test', newValue)
    setSelectedDealer(newValue.Value);
  };

  useEffect(() => {
    // Sundealerlist();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/mdpcompletionYear', { login_id: login_id });
        // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: '5103176' });
        if (response.status === 200) {
          // setsubdealerlist(response.data.DEALER_CODE);
          const dealerdata = response.data.data;


          const Subdealer_List = dealerdata.map((type) => ({
            value: type.fyear,
            label: type.fyear,
          }));

          setsubdealerlist(Subdealer_List);
          setSelectedGroup(Subdealer_List[0]);


        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, []);


  // get Activity Group





  const handleactivityGroupChange = (event, selectedOption) => {
    // This will be triggered when a branch is selected from the dropdown
    setSelectedactivitygroup(selectedOption);  // Update the selected branch
  };


  // end  get Activity Group

  // end segmant load 
  const [activitydescriptionlist, setactivitydescriptionlist] = useState([]);
  const [selecteddescriptiongroup, setSelecteddescriptiongroup] = useState(null);


  const [segmentlist, setsegmentlist] = useState([]);
  const [selectedsegment, setSelectedsegment] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/fillmdpsegment');
        // const response = await axios.post(BASE_URL + '/getsubdelaerlist', { dealer_code: '5103176' });
        if (response.status === 200) {
          // setsubdealerlist(response.data.DEALER_CODE);
          const segmentdata = response.data.data;


          const segment_List = segmentdata.map((type) => ({
            value: type.SBU_Code,
            label: type.SBU_Name,
          }));




          setsegmentlist(segment_List);
          setSelectedsegment(segment_List[0]);


        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, []);

  const handlesegmentChange = (event, selectedOption) => {
    // This will be triggered when a branch is selected from the dropdown
    setSelectedsegment(selectedOption);  // Update the selected branch
  };
  // end segmant load 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/fillmdpActivityGroup');
        if (response.status === 200) {
          const activitydata = response.data.data;

          const activitygroup_List = activitydata.map((type) => ({
            value: type.PACTIVITYGROUP_CODE,
            label: type.DESCRIPTION,
          }));

          setactivitygrouplist(activitygroup_List);
          setSelectedactivitygroup(activitygroup_List[0]);

          // After fetching, trigger the second API call
          setIsActivityGroupFetched(true);
        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, []); // This runs once when the component mounts

  useEffect(() => {
    if (!isActivityGroupFetched) return;  // Prevent the second API call if first isn't fetched yet

    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/fillmdpCmdActivityType', { ActivityGroup: selectedactivitygroup.value });
        if (response.status === 200) {
          const descriptiondata = response.data.data;

          const description_List = descriptiondata.map((type) => ({
            value: type.ACTIVITY_CODE,
            label: type.DESCRIPTION,
          }));

          setactivitydescriptionlist(description_List);
          setSelecteddescriptiongroup(description_List[0]);
        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, [isActivityGroupFetched, selectedactivitygroup]);


  const [labels, setLabels] = useState({
    Lblspec: 'Details (Size / Sq. Feet / No. of Participants)',
    Lblspec2: 'Details (Size / Sq. Feet / No. of Participants)'
  });
  const [visibility, setVisibility] = useState({
    Lblspec2: false,
    txtSPECIFIC_DETAILS2: false
  });
  const [txtSPECIFIC_DETAILS, setTxtSPECIFIC_DETAILS] = useState('');
  const [txtSPECIFIC_DETAILS2, setTxtSPECIFIC_DETAILS2] = useState('');

  const [txtSPECIFIC_DETAILSmode, setTxtSPECIFIC_DETAILSmode] = useState(false);
  const [txtSPECIFIC_DETAILS2mode, setTxtSPECIFIC_DETAILS2mode] = useState(false);
  const [fileupload, setfileupload] = useState(false);

  const [dropDownListVisible, setDropDownListVisible] = useState(false);
  const [dropDownList, setDropDownList] = useState([]);
  const [selectedDropDownList, setselectedDropDownList] = useState([]);

  useEffect(() => {
    // Ensure the first API call has completed successfully and description group is selected
    if (!selecteddescriptiongroup) return;

    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/mdploadTxt', { activity_code: selecteddescriptiongroup.value });
        if (response.status === 200) {
          // Extract data from the response
          const { data, labels, visibility, txtSPECIFIC_DETAILS, txtSPECIFIC_DETAILS2, txtSPECIFIC_DETAILSmode, txtSPECIFIC_DETAILS2mode, dropDownListVisible, fileuploadVisible, dropDownList } = response.data;

          // Set labels, visibility, and dropdown data
          setLabels(labels);
          setVisibility(visibility);
          setTxtSPECIFIC_DETAILS(txtSPECIFIC_DETAILS);
          setTxtSPECIFIC_DETAILS2(txtSPECIFIC_DETAILS2);

          setTxtSPECIFIC_DETAILSmode(txtSPECIFIC_DETAILSmode);
          setTxtSPECIFIC_DETAILS2mode(txtSPECIFIC_DETAILS2mode);

          setDropDownListVisible(dropDownListVisible);
          setDropDownList(dropDownList);

          if (fileuploadVisible === '1') {
            setfileupload(true);
          }
          else {
            setfileupload(false);
          }


          const transformedDropDownList = dropDownList.map(item => ({
            value: item,    // The item itself can be the value
            label: item     // Display the same item as the label
          }));
          setDropDownList(transformedDropDownList);

          setselectedDropDownList(transformedDropDownList[0]);


        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };

    fetchData();
  }, []);


  const handledeDropDownListChange = (event, selectedOption) => {
    // This will be triggered when a branch is selected from the dropdown
    setselectedDropDownList(selectedOption);  // Update the selected branch
  };

  // const handleTextChange = (e) => {
  //   const value = e.target.value;

  //   // If in numeric-only mode
  //   if (txtSPECIFIC_DETAILSmode) {

  //     // Only allow numbers and empty string (for clearing input)
  //     if (/^\d*$/.test(value)) {
  //       setTxtSPECIFIC_DETAILS(value);
  //     }
  //   } else {

  //     // Allow any character (if mode is false)
  //     setTxtSPECIFIC_DETAILS(value);
  //   }
  // };
  const handleTextChange = (e) => {
  const value = e.target.value;

  // numeric-only mode
  if (txtSPECIFIC_DETAILSmode) {
    // allow only numbers
    if (/^\d*$/.test(value)) {
      setTxtSPECIFIC_DETAILS(value);
      setError('');
    } else {
      // ❗do NOT clear value
      setError(`${labels.Lblspec} should contain numbers only`);
    }
  } else {
    setTxtSPECIFIC_DETAILS(value);
    setError('');
  }
};


  const handleTextChange2 = (e) => {
    const value = e.target.value;

    // If in numeric-only mode
    if (txtSPECIFIC_DETAILS2mode) {
      // Only allow numbers and empty string (for clearing input)
      if (/^\d*$/.test(value)) {
        setTxtSPECIFIC_DETAILS2(value);
      }
    } else {
      // Allow any character (if mode is false)
      setTxtSPECIFIC_DETAILS2(value);
    }
  };

  const handlesubmit = () => {
 if (!txtSPECIFIC_DETAILS || txtSPECIFIC_DETAILS.trim() === '') {
    setError(`${labels.Lblspec} is required`);
    return;
  }
    setOpen(true);
  
    const formData = new FormData();
    // Add file, login_id, and other form fields
    formData.append('file', serialNoImage[0]);
    formData.append('login_id', login_id);
    formData.append('iscomplete', iscompled);
    formData.append('isclosed', isclosed);
    formData.append('activityType', selecteddescriptiongroup.value);
    formData.append('docno', docno);
    formData.append('plandate', plandate);
  
    // Date formatting using dayjs (if using dayjs)
    const formattedDate = dayjs(selectedfromDate).format('YYYY-MM-DD');
    const formattedtoDate = dayjs(selectedtoDate).format('YYYY-MM-DD');
    
    formData.append('fromdate', formattedDate);  
    formData.append('toDate', formattedtoDate);
  
    //formData.append('closedremarks', description);
    formData.append('closedremarks', Remark);
    formData.append('budget', budget);
   formData.append('dealerContribution', dealerbudget);
   
  
    // Handling the specific details
    if (dropDownListVisible === true) {
      formData.append('specificDetails2', selectedDropDownList.value || "");
    } else {
      formData.append('specificDetails2', txtSPECIFIC_DETAILS2 || "");
    }
    formData.append('specificDetails', txtSPECIFIC_DETAILS || "");
    formData.append('segmentCode', selectedsegment.value);
    formData.append('segmentName', selectedsegment.label);
  
    // Post request
    axios.post(BASE_URL + '/mdpdocumentcomplete', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Important for file uploads
      }
    })
    .then(response => {
      if (response.status === 200) {
             setOpen(false);
                           Swal.fire({
                               icon: "success",
                               text: response.data.text || 'Data saved successfully!',
                           }).then((result) => {
                             setOpen(false);
                               if (result.isConfirmed) {
                                   window.location.reload();
                               }
                           });
      } else {
        Swal.fire({
          icon: "warning",
          text: 'Unexpected response status. Please try again.',
        });
      }
    })
    .catch(error => {
      if (error.response) {
        Swal.fire({
          icon: "warning",
          text: `Error: ${error.response.data.text}`,
        });
      } else if (error.request) {
        console.error('No response received');
      } else {
        console.error('Error setting up the request:', error.message);
      }
    });
  };



  const handledescriptionGroupChange = (event, selectedOption) => {
    // This will be triggered when a branch is selected from the dropdown
    setSelecteddescriptiongroup(selectedOption);  // Update the selected branch
  };


  //end get activity description

  const [financialYearCount, setFinancialYearCount] = useState(0);
  const [financialYearOptions, setFinancialYearOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null); // Initialize the selected item



  // Handle the change event for selecting a new item
  const handleItemChange = (event, newValue) => {
    setSelectedItem(newValue);
  };
  const acceptedFileTypes = [
    'image/jpeg',    // .jpg, .jpeg
    'image/png',     // .png
    'application/pdf',   // .pdf
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.ms-powerpoint',  // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/zip', // .zip
    'text/plain',  // .txt
    'text/csv'     // .csv
  ];
  const createInvoiceImageProps = (image, setImage) => ({
    // accept: '.pdf',
    onRemove: (file) => {
      const newFileList = image.filter(item => item.uid !== file.uid);
      setImage(newFileList);
    },
    beforeUpload: (file) => {
      const isAcceptedFileType = acceptedFileTypes.includes(file.type);
      if (!isAcceptedFileType) {
        message.error('You can only upload PDF files!');
        return false;
      }
      setImage([file]);
      return false;
    },
    fileList: image,
  });



  const [pendingStatusCount, setPendingStatusCount] = useState([]);
  const [pendingStatus, setPendingStatus] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchPendingStatus = async () => {
      try {
        setLoading(true);
        const response = await axios.post(BASE_URL + '/loadmdppendingstatus', { login_id: login_id, userGroupCode: userGroupCode });

        if (response.status === 200) {
          // Check if the API response contains data
          if (response.data.pendingStatusCount) {
            setPendingStatusCount(response.data.pendingStatusCount);
          }
          if (response.data.pendingStatus) {
            setPendingStatus(response.data.pendingStatus);
          }
        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        setError(error);
        Swal.fire({
          icon: "error",
          text: 'There was an error fetching data. Please try again later.'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPendingStatus();
  }, [login_id]);

  const maxRows = 6;
  const rowCount = pendingStatus.length;


  const [subgrouppcode, setsubgrouppcode] = useState([]);

  const handleGroupChange = (event, selectedOption) => {
    // This will be triggered when a branch is selected from the dropdown
    setSelectedGroup(selectedOption);  // Update the selected branch
  };






  const [rptcode, setrptcode] = useState([]);



  const [selectedDealername, setSelectedDealername] = useState('');



  //handlitemChange

  const [selecteditemdesc, setselecteditemdesc] = useState('');
  const [mdpgrid, setmdpgrid] = useState([]);
  const [mdpgridcommon, setmdpgridcommon] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/mdploadgridcomplotion', { login_id: login_id, fyear: selectedGroup.value });
        if (response.status === 200) {
          setmdpgrid(response.data.data);
        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, [login_id, selectedGroup]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/mdploadgridcomplotioncommon', { login_id: login_id, fyear: selectedGroup.value });
        if (response.status === 200) {
          setmdpgridcommon(response.data.data);
        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      } catch (error) {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.message}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      }
    };
    fetchData();
  }, [login_id, selectedGroup]);









  const [isCheckedassign, setIsCheckedassign] = useState(false);
  const [isCheckedview, setIsCheckedview] = useState(false);
  const [iscompled, setiscompled] = useState(false);
  const [isclosed, setisclosed] = useState(false);

  const handleCompleteCheckboxChange = (event) => {
    setiscompled(event.target.checked);
    setisclosed(false)
    setshowremarks(false);
  };
  const [showremarks, setshowremarks] = useState(false);
  const handleclosedCheckboxChange = (event) => {
    setiscompled(false)
    setisclosed(event.target.checked);
    setshowremarks(true);
  };
  // Handle checkbox state change
  const handleassignCheckboxChange = (event) => {


    setIsCheckedassign(event.target.checked);
    setIsCheckedview(false);


    setshowTableCOMMONON(false);
    setShowTable(true)


  };
  const handleviewCheckboxChange = (event) => {
    setIsCheckedview(event.target.checked);
    setIsCheckedassign(false);
    setshowTableCOMMONON(true);
    setShowTable(false);
  };

  const [open1, setOpen1] = useState(false);

  const handleToggle = () => setOpen1(!open1);
  const [searchTerm, setSearchTerm] = useState('');


  let mdpgrid1 = mdpgrid || []; // If mdpgrid is undefined or null, initialize it as an empty array

  const filteredItems = mdpgrid1.filter((row) => {
    const lowerSearchTerm = searchTerm.toLowerCase();

    return (
      (row.doc_NO && row.doc_NO.toLowerCase().includes(lowerSearchTerm)) ||
      (row.DEALER_CODE && row.DEALER_CODE.toLowerCase().includes(lowerSearchTerm)) ||
      (row.DEALER_NAME && row.DEALER_NAME.toLowerCase().includes(lowerSearchTerm))
    );
  });

  let mdpgrid1common = mdpgridcommon || []; // If mdpgrid is undefined or null, initialize it as an empty array

  const filteredItemscommon = mdpgrid1common.filter((row) => {
    const lowerSearchTerm = searchTerm.toLowerCase();

    return (
      (row.doc_NO && row.doc_NO.toLowerCase().includes(lowerSearchTerm)) ||
      (row.DEALER_CODE && row.DEALER_CODE.toLowerCase().includes(lowerSearchTerm)) ||
      (row.DEALER_NAME && row.DEALER_NAME.toLowerCase().includes(lowerSearchTerm))
    );
  });


  const [dealercode, setdealercode] = useState(null)
  const [docno, setdocno] = useState(null)
  const [dealername, setdealername] = useState(null)
  const [activityname, setactivityname] = useState(null)
  const [plandate, setplandate] = useState(null)
  const [execode, setexecode] = useState(null)
  const [exename, setexename] = useState(null)
  const [branch1, setbranch1] = useState(null)

  const handleOpenCard = (rowData) => {

    setShowfirstpage(false);
    setShowactivity(true);

    setdocno(rowData.doc_NO); 


    axios.post(BASE_URL + '/mdpeditcompletionGrid', {
      code: rowData.doc_NO,
      login_id: login_id
    })
      .then(response => {
        if (response.status === 200) {
          //   setmdpgrid(response.data.data);
          setLabels(response.data.labels);
          setVisibility(response.data.visibility);
          setdealername(response.data.txtDealerName);
          setactivityname(response.data.txtActivityName);
          setplandate(response.data.txtPlanDate);
          setDropDownList(response.data.dropDownList1Items)
          setDropDownListVisible(response.data.dropDownList1Visible);
          //window.location.reload();

          const transformedDropDownList = response.data.dropDownList1Items.map(item => ({
            value: item,    // The item itself can be the value
            label: item     // Display the same item as the label
          }));

          // Set the dropdown list and the selected item (if any items are available)
          setDropDownList(transformedDropDownList);

          // Set the first item as selected (if the list is not empty)
          if (transformedDropDownList.length > 0) {
            setselectedDropDownList(transformedDropDownList[0]);
          } else {
            setselectedDropDownList(null); // Set to null or default value if empty
          }

        } else {
          Swal.fire({
            icon: "warning",
            text: 'Unexpected response status. Please try again.'
          });
        }
      })
      .catch(error => {
        if (error.response) {
          Swal.fire({
            icon: "warning",
            text: `Error: ${error.response.data.text}`
          });
        } else if (error.request) {
          console.error('No response received');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      });


  };
  const [selectedtoDate, setSelectedtoDate] = useState(dayjs());
  const handletoDateChange = (date) => {
    setSelectedtoDate(date);
  };
  const [selectedfromDate, setSelectedfromDate] = useState(dayjs());
  const handlefromDateChange = (date) => {
    setSelectedfromDate(date);
  };
  return (
    <>
      <br />

      <div className="container" style={{ justifyContent: 'center' }}>

        <br />
        {showfirstpage && (
          <>

            <br />
            <div className='row'>

              <div className='col-md-4'>

                <Autocomplete
                  label="Year"
                  required={true}
                  options={subdealerlist}  // Pass the mapped branches here
                  value={selectedGroup}  // Set the selected branch
                  onChange={handleGroupChange}  // Handle the change event
                  getOptionLabel={(option) => option.label}  // Define how to display the label
                  isOptionEqualToValue={(option, value) => option.Value === value.Value}  // Custom comparison function
                  renderInput={(params) => <TextField {...params} label="FYear" />}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                  View Dealer Activity
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  type="checkbox"
                  checked={isCheckedassign}
                  onChange={handleassignCheckboxChange}
                />
              </div>


              <div className="col-md-4">
                <label className="form-label" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                  View Common Activity
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  type="checkbox"
                  checked={isCheckedview}
                  onChange={handleviewCheckboxChange}
                />
              </div>
            </div>




            <br />
            {showTable && (
              <div>

                <TextField
                  id="filled-search"
                  label="Search field"
                  type="search"
                  variant="filled"

                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    endAdornment: <SearchIcon />,
                  }}
                />


                <TableContainer component={Paper} sx={{ width: '100%', maxHeight: '400px', overflow: 'auto' }} >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1 }}>S.No</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }}>Activity Code</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>FYEAR</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1  }}>Activity Description </TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>DEALER CODE </TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>DEALER NAME</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>From Date</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1  }}>To Date</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>Active</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1  }}>Approved</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1  }}>Rejected</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1  }}>Level1</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' ,position: 'sticky', top: 0, zIndex: 1  }}>Level2</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black'  ,position: 'sticky', top: 0, zIndex: 1 }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredItems.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No data available
                          </TableCell>
                        </TableRow>
                      ) : (
                        filteredItems.map((row, index) => (
                          <>
                            <TableRow key={index}>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{index + 1}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.doc_NO}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.FYEAR}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.ACTIVITYTYPE_DESC}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.DEALER_CODE}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.DEALER_NAME}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.FROM_DATE}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.TO_DATE}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.ACTIVE === "1"} />
                              </TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.APPROVED === "1"} />
                              </TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.REJ_IND === "1"} />
                              </TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.LEVELS === "True"} />
                              </TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.LEVELss === "True"} />
                              </TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>

                                <Button variant="contained" onClick={() => handleOpenCard(row)} color="primary" >Add/Edit</Button>
                                {/* <Button variant="contained"   onClick={() => handleOpenCard(row)} color="primary" >Delivery Challan</Button> */}
                              </TableCell>
                            </TableRow>
                            {/* ))} */}
                          </>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

              </div>
            )}

            {showTableCOMMONON && (
              <div>

                <TextField
                  id="filled-search"
                  label="Search field"
                  type="search"
                  variant="filled"

                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    endAdornment: <SearchIcon />,
                  }}
                />


                <TableContainer component={Paper} sx={{ width: '100%', maxHeight: '400px', overflow: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Activity Code</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>FYEAR</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Activity Description </TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>DEALER CODE </TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>DEALER NAME</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>From Date</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>To Date</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Active</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Approved</TableCell>
                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Rejected</TableCell>

                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredItemscommon.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No data available
                          </TableCell>
                        </TableRow>
                      ) : (
                        filteredItemscommon.map((row, index) => (
                          <>
                            {/* {mdpgrid && mdpgrid.map((row, index) => ( */}
                            <TableRow key={index}>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{index + 1}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.doc_NO}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.FYEAR}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.ACTIVITYTYPE_DESC}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.DEALER_CODE}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.DEALER_NAME}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.FROM_DATE}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.TO_DATE}</TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.ACTIVE === "1"} />
                              </TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.APPROVED === "1"} />
                              </TableCell>
                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                <Checkbox checked={row.REJ_IND === "1"} />
                              </TableCell>

                              <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>

                                <Button variant="contained" onClick={() => handleOpenCard(row)} color="primary" >Add/Edit</Button>
                                {/* <Button variant="contained"   onClick={() => handleOpenCard(row)} color="primary" >Delivery Challan</Button> */}
                              </TableCell>
                            </TableRow>
                            {/* ))} */}
                          </>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

              </div>
            )}
          </>
        )}

        {showactivity && (
          <>
            <div>
              <center><h3 style={{ padding: '2px', background: '#e3fafe', color: 'black' }} >
                Dealer Development Plan</h3></center>



            </div><br />
            <div>

              <Card style={{
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
                height: 'auto', // Adjust the height to fit content
                // maxHeight: '300px', // Set a maximum height

                padding: '20px', // Add padding to prevent the content from touching the edges
                boxSizing: 'border-box',

              }}>

                <Box>
                  <center><h3 style={{ padding: '2px', background: '#e3fafe', color: 'black', fontweight: 'bolder' }} >Activity Details</h3></center>
                  <div className='row'>
                    <div className='col-md-4'>
                      <label style={{ fontWeight: 'bolder' }}>Sr.NO<span style={{ color: 'red' }}> *</span></label>
                      <br />

                      <TextField
                        disabled
                        fullWidth
                        id="PlanYear"
                        label=""
                        variant="outlined"
                        value={docno}
                        InputProps={{
                          style: {
                            height: '35px', // Adjust this value to set the desired height
                            padding: '5px 10px', // Adjust padding to further control the height
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem', // Optional: change font size if needed
                          },
                        }}
                      />
                    </div>



                    <div className="col-md-4">
                      <label className="form-label" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        Completed
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <input
                        type="checkbox"
                        checked={iscompled}
                        onChange={handleCompleteCheckboxChange}
                      />
                    </div>


                    <div className="col-md-4">
                      <label className="form-label" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        Closed(Not Completed)
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <input
                        type="checkbox"
                        checked={isclosed}
                        onChange={handleclosedCheckboxChange}
                      />
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-4'>
                      <label style={{ fontWeight: 'bolder' }}>Dealer Name<span style={{ color: 'red' }}> *</span></label>
                      <br />

                      <TextField
                        disabled
                        fullWidth
                        id="PlanYear"
                        label=""
                        variant="outlined"
                        value={dealername}
                        InputProps={{
                          style: {
                            height: '35px', // Adjust this value to set the desired height
                            padding: '5px 10px', // Adjust padding to further control the height
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem', // Optional: change font size if needed
                          },
                        }}
                      />
                    </div>
                    <div className='col-md-4'>
                      <label style={{ fontWeight: 'bolder' }}>Activity Name<span style={{ color: 'red' }}> *</span></label>
                      <br />

                      <TextField
                        disabled
                        fullWidth
                        id="PlanYear"
                        label=""
                        variant="outlined"
                        value={activityname}
                        InputProps={{
                          style: {
                            height: '35px', // Adjust this value to set the desired height
                            padding: '5px 10px', // Adjust padding to further control the height
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem', // Optional: change font size if needed
                          },
                        }}
                      />
                    </div>
                    <div className='col-md-4'>
                      <label style={{ fontWeight: 'bolder' }}>Plan Date<span style={{ color: 'red' }}> *</span></label>
                      <br />

                      <TextField
                        disabled
                        fullWidth
                        id="PlanYear"
                        label=""
                        variant="outlined"
                        value={plandate}
                        InputProps={{
                          style: {
                            height: '35px', // Adjust this value to set the desired height
                            padding: '5px 10px', // Adjust padding to further control the height
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem', // Optional: change font size if needed
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-4'>
                      <label style={{ fontWeight: 'bolder' }}>Activity Conducted From Date<span style={{ color: 'red' }}> *</span></label>
                      <br />

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={2}>
                          <DatePicker
                            value={selectedfromDate}  // Ensure `value` is a dayjs object
                            onChange={handlefromDateChange}
                            format="DD/MM/YYYY"
                            label=""
                            inputRef={fromdateInputRef}
                            error={!!errorfromdate}
                            helperText={errorfromdate}
                            sx={{
                              '& .MuiInputBase-root': {
                                height: '40px',
                              },
                            }}
                            InputProps={{
                              style: {
                                height: '40px',
                                padding: '5px 10px',
                              },
                            }}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </div>

                    <div className='col-md-4'>
                      <label style={{ fontWeight: 'bolder' }}>Activity Conducted To Date<span style={{ color: 'red' }}> *</span></label>
                      <br />


                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={2}>
                          <DatePicker
                            value={selectedtoDate}  // Ensure `value` is a dayjs object
                            onChange={handletoDateChange}
                            format="DD/MM/YYYY"
                            label=""
                            inputRef={todateInputRef}
                            error={!!errortodate}
                            helperText={errortodate}
                            sx={{
                              '& .MuiInputBase-root': {
                                height: '40px',
                              },
                            }}
                            InputProps={{
                              style: {
                                height: '40px',
                                padding: '5px 10px',
                              },
                            }}
                          />
                        </Stack>
                      </LocalizationProvider>

                    </div>

                    <div className='col-md-4'>

                      <label style={{ fontWeight: 'bolder' }}>
                        {labels.Lblspec} <span style={{ color: 'red' }}>*</span>
                      </label>
                      <br />



                      <TextField
                        fullWidth
                        id="ExeName"
                        label=""
                        variant="outlined"
                        value={txtSPECIFIC_DETAILS}
                        onChange={handleTextChange}



                        inputRef={billNoInputRef}
                        error={!!error}
                        helperText={error}

                        InputProps={{
                          style: {
                            height: '35px', // Adjust this value to set the desired height
                            padding: '5px 10px', // Adjust padding to further control the height
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem', // Optional: change font size if needed
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className='row'>


                    <div className='col-md-4'>
                      <label style={{ fontWeight: 'bolder' }}>Actual Total Expenses<span style={{ color: 'red' }}> *</span></label>
                      <br />

                      <TextField

                        fullWidth
                        id="name"
                        label=""
                        inputRef={budgetInputRef}
                        error={!!errorbudget}
                        helperText={errorbudget}
                        variant="outlined"
                        value={budget}
                        onChange={(e) => setbudget(e.target.value)}
                        InputProps={{
                          style: {
                            height: '35px', // Adjust this value to set the desired height
                            padding: '5px 10px', // Adjust padding to further control the height
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem', // Optional: change font size if needed
                          },
                        }}
                      />
                    </div>
                    <div className='col-md-4'>

                      <label style={{ fontWeight: 'bolder' }}>
                        Actual Dealer contribution <span style={{ color: 'red' }}>*</span>
                      </label>
                      <br />
                      <TextField
                        fullWidth
                        id="ExeName"
                        label=""
                        variant="outlined"
                        value={dealerbudget}
                        onChange={(e) => setdealerbudget(e.target.value)}
                        inputRef={dealerbudgetInputRef}
                        error={!!errordealerbudget}
                        helperText={errordealerbudget}
                        InputProps={{
                          style: {
                            height: '35px', // Adjust this value to set the desired height
                            padding: '5px 10px', // Adjust padding to further control the height
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem', // Optional: change font size if needed
                          },
                        }}
                      />
                    </div>
                    <div className='col-md-4'>


                      {visibility.Lblspec2 && (
                        <div>
                          <label style={{ fontWeight: 'bolder' }}>
                            {labels.Lblspec2} <span style={{ color: 'red' }}>*</span>
                          </label>
                          <br />

                          {dropDownListVisible ? (
                            <Autocomplete
                              label=""
                              required={true}
                              options={dropDownList}  // Pass the mapped descriptions here
                              value={selectedDropDownList}  // Set the selected description
                              onChange={handledeDropDownListChange}  // Handle the change event
                              getOptionLabel={(option) => option.label}  // Define how to display the label
                              isOptionEqualToValue={(option, value) => option.value === value.value}  // Custom comparison function
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label=""
                                  InputProps={{
                                    ...params.InputProps,  // Retain any existing input properties
                                    style: {
                                      height: '35px', // Adjust this value to set the desired height
                                      padding: '5px 10px', // Adjust padding to further control the height
                                    },
                                  }}
                                  InputLabelProps={{
                                    style: {
                                      fontSize: '0.9rem', // Optional: change font size if needed
                                    },
                                  }}
                                />
                              )}
                            />
                          ) : (
                            <TextField
                              fullWidth
                              id="ExeName"
                              label=""
                              variant="outlined"
                              value={txtSPECIFIC_DETAILS2}
                              onChange={handleTextChange2}
                              inputRef={txtSPECIFIC_DETAILS2InputRef}
                              error={!!errortxtSPECIFIC_DETAILS2}
                              helperText={errortxtSPECIFIC_DETAILS2}
                              InputProps={{
                                style: {
                                  height: '35px', // Adjust this value to set the desired height
                                  padding: '5px 10px', // Adjust padding to further control the height
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  fontSize: '0.9rem', // Optional: change font size if needed
                                },
                              }}
                            />
                          )}
                        </div>
                      )}

                      {/* {dropDownListVisible && (
                <div>
                    <label>Choose an option:</label>
                    <select>
                        {dropDownList.map((item, index) => (
                            <option key={index} value={item}>
                                {item}
                            </option>
                        ))}
                    </select>
                </div>
            )} */}
                    </div>
                  </div>
                  {fileupload && (
                    <div className='row'>
                      <div className='col-md-4'>
                        <label style={{ fontWeight: 'bolder' }}>UplaodFile<span style={{ color: 'red' }}> *</span></label>
                        <br />
                        {/* <Upload
      fileList={upload}  // Use the state for file list
      onChange={handleuploadChange}  // Handle changes
      accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.xls,.xlsx,.doc,.docx,.zip,.txt,.csv"  // Accept multiple file types
      showUploadList={{ showPreviewIcon: true, showRemoveIcon: true }} // Optional: Show preview and remove icon
      maxCount={1}  // Only allow 1 file (remove or change if you want more)
    > */}
                        <Upload   {...createInvoiceImageProps(serialNoImage, setSerialNoImage)} maxCount={1}>
                          <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Account Statements *</Btn>
                        </Upload>
                        {/* <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Upload Files</Btn> */}
                        {/* <Button icon={<UploadOutlined />} style={{ width: '100%' }}>
        
      </Button> */}
                        {/* </Upload> */}
                      </div>
                    </div>
                  )}
                  {showremarks && (
                    <>
                      <div className='row'>


                        <div className='col-md-4'>

                          <label style={{ fontWeight: 'bolder' }}>
                            Closed Remark <span style={{ color: 'red' }}>*</span>
                          </label>
                          <br />



                          <TextField
                            fullWidth
                            id="ExeName"
                            label=""
                            variant="outlined"
                            value={Remark}
                            onChange={(e) => setRemark(e.target.value)}

                            InputProps={{
                              style: {
                                height: '35px', // Adjust this value to set the desired height
                                padding: '5px 10px', // Adjust padding to further control the height
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                fontSize: '0.9rem', // Optional: change font size if needed
                              },
                            }}
                          />
                        </div>

                      </div>

                    </>)}

                </Box>
              </Card>

              <div className='row'>
                <div className="col-md-4">
                </div>
                <div className="col-md-4">
                  {/* <Button size="small" fullWidth variant="contained" onClick={handlePriceList} ><b>View</b></Button> */}
                  <Button size="small" fullWidth variant="contained" onClick={handlesubmit} ><b>SUBMIT</b></Button>
                </div>
              </div>

            </div>

          </>

        )}
        <br />

        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
          <CircularProgress color="inherit" />
        </Backdrop>


      </div>
    </>
  );
};


